<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col md="9">
              <h3>Generaciones</h3>
            </b-col>
            <b-col md="3">
              <b-button
                id="btn-add-generation"
                v-b-modal.modal-prevent-closing
                variant="relief-primary"
                class="mb-2 mt-1"
                block
              >
                <feather-icon
                  icon="PlusCircleIcon"
                  class="mr-50"
                />
                <span class="align-middle">agregar generación</span>
              </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="9">
              <b-form-group label="Convocatoria">
                <v-select
                  v-model="convocatoriaSelected"
                  label="convocatoria_nombre"
                  :reduce="opc => opc.convocatoria_id"
                  placeholder="selecciona un tipo de convocatoria"
                  :options="convocatoriasList"
                  :clearable="false"
                  @input="fetchGeneraciones"
                >
                  <!-- @option:deselected="advanceSearch" -->
                  <template slot="no-options">
                    No hay registros.
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Generaciones">
                <v-select
                  v-model="generacionSelected"
                  label="descripcion"
                  :reduce="opc => opc.id"
                  placeholder="selecciona una generacion"
                  :options="generacionesList"
                  :clearable="false"
                  @input="genSelected"
                >
                  <template slot="no-options">
                    No hay generaciones.
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- modal -->
          <b-modal
            id="modal-prevent-closing"
            ref="generation-modal"
            title="Agregar Generación"
            ok-title="Guardar"
            cancel-variant="outline-danger"
            centered
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk"
          >
            <form
              ref="form"
              @submit.stop.prevent="handleSubmit"
            >
              <b-form-group
                :state="stateGeneration"
                label="Generación"
                label-for="generacion-input"
                invalid-feedback="Generación es requerido"
              >
                <b-form-input
                  id="generacion-input"
                  v-model.trim="nameGeneration"
                  :state="stateGeneration"
                  required
                />
              </b-form-group>
              <b-form-group label="Convocatoria">
                <v-select
                  v-model="convForm"
                  label="convocatoria_nombre"
                  :reduce="opc => opc.convocatoria_id"
                  placeholder="selecciona un tipo de convocatoria"
                  :options="convocatoriasList"
                  :clearable="false"
                >
                  <!-- @input="fetchGeneraciones" -->
                  <!-- @option:deselected="advanceSearch" -->
                  <template slot="no-options">
                    No hay registros.
                  </template>
                </v-select>
              </b-form-group>
            </form>
          </b-modal>

          <!-- <b-overlay
            id="overlay-background"
            :show="isLoading"
            variant="transparent"
            :opacity="1.0"
            blur="2px"
            rounded="sm"
          >
            <b-list-group>
              <b-list-group-item
                v-for="generacion in generacionesList"
                :key="generacion.id"
                button
                :active="isSelected === generacion.descripcion ? true : false"
                @click="
                  () => {
                    idGen = generacion.id
                    desGen = generacion.descripcion
                    isSelected = desGen
                  }
                "
              > -->
          <!-- $router.push({
                      name: 'generacion-detalles',
                      params: {
                        generacionId: generacion.id,
                      },
                    }) -->
          <!-- aqui voy hacer el routeo -->
          <!-- <strong>{{ generacion.descripcion }} </strong>
              </b-list-group-item>
            </b-list-group>
          </b-overlay> -->
        </b-card>
      </b-col>
      <b-col cols="12">
        <!-- <becarios-generacion
          v-if="isSelected"
          :id="idGen"
          :description="desGen"
        /> -->
        <generacion
          v-if="isSelected"
          :id="generacionSelected"
          :description="desGen"
        />
        <b-card
          v-else
          title="Becarios de Generación"
        >
          <b-alert
            :show="!isSelected"
            variant="primary"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="AlertCircleIcon"
              />
              <span
                class="ml-25"
              >Selecciona una generación para visualizar la lista de Becarios
                de esta misma.</span>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  BAlert,
  BButton,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  // BListGroup,
  // BListGroupItem,
  BModal,
  VBModal,
  BRow,
  // BOverlay,
} from 'bootstrap-vue'

import vSelect from 'vue-select'

import GeneracionesService from '@/services/GeneracionesService'
import CatalogosService from '@/services/CatalogosService'

import Generacion from './components/Generacion.vue'
// import BecariosGeneracion from './components/BecariosGeneracion2.vue'
// import BecariosGeneracion from './components/BecariosGeneracion2.vue'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BAlert,
    BButton,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    // BListGroup,
    // BListGroupItem,
    BModal,
    // BOverlay,
    BRow,
    // BecariosGeneracion,
    vSelect,
    Generacion,
  },
  data: () => ({
    nameGeneration: '',
    stateGeneration: null,
    idGen: null,
    desGen: null,
    isSelected: null,
    generacionesList: [],
    generacionSelected: null,
    convocatoriasList: [],
    convocatoriaSelected: null,
    isLoading: false,
    user: null,
    convForm: null,
  }),
  async mounted() {
    const { id } = this.getDataUser()
    this.user = id
    const resp = await this.fetchConvByUser()

    if (resp > 0) {
      this.convocatoriaSelected = this.convocatoriasList[0].convocatoria_id
      this.fetchGeneraciones()
    }
  },
  methods: {
    ...mapGetters('user', ['getDataUser']),
    msg({ title, text, icon }) {
      return this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    async fetchConvByUser() {
      const response = await CatalogosService.getConvByUser({
        usuario: this.user,
      })
      if (response.data) {
        const { data } = response
        this.convocatoriasList = data
        return data.length
      }
      return 0
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.stateGeneration = valid
      return valid
    },
    resetModal() {
      this.nameGeneration = ''
      this.stateGeneration = null
    },
    genSelected() {
      this.generacionesList.forEach(e => {
        if (e.id === this.generacionSelected) {
          this.desGen = e.descripcion
          this.isSelected = this.desGen
        }
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        // TODO: Mostrar msg de error
        return
      }

      // TODO llamar petición
      await this.addGeneration()
      // this.submittedNames.push(this.name)
      // // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['generation-modal'].toggle('#btn-add-generation')
      })
    },
    fetchGeneraciones() {
      GeneracionesService.getGenByConv({
        active: true,
        convocatoria: this.convocatoriaSelected,
      })
        .then(response => {
          this.generacionesList = response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchGeneracion() {},
    addGeneration() {
      const vm = this
      GeneracionesService.addGeneration({
        descripcion: vm.nameGeneration,
        convocatoria: vm.convForm,
      })
        .then(resp => {
          if (resp.status === 201) {
            vm.fetchGeneraciones()
            vm.msg({
              title: 'OK',
              text: `Generación ${vm.nameGeneration} registrada con éxito!`,
              icon: 'success',
            })
          }
        })
        .catch(err => {
          if (err.response.status === 400) {
            vm.msg({
              title: 'Error!',
              text: 'La generación que intentas registrar ya existe.',
              icon: 'error',
            })
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
